module.exports = __webpack_public_path__ + "img/包钢钢铁.39130793.png";